import { motion } from "framer-motion";
import { BadgeCheck, TrendingUp } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const Community = () => {
  const { t } = useLanguage();
  return (
    <section id="community" className="py-20 sm:py-28 bg-[#E9F2EF]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.5 }}
          className="text-xs font-mono uppercase tracking-[0.22em] text-[#C85A17] font-semibold">
          {t.community.overline}
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1 }}
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#17181A] mt-4 mb-12" data-testid="community-heading">
          {t.community.heading}
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.community.items.map((item, i) => (
            <motion.div key={item.name}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: 0.1 * i, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className={`rounded-2xl border border-[#E7DFD5] bg-white p-8 flex flex-col shadow-[0_16px_40px_-24px_rgba(23,24,26,0.18)] ${i === 1 ? "md:translate-y-8" : ""}`}
              data-testid={`testimonial-card-${i}`}>
              <p className="font-serif text-lg leading-relaxed text-[#17181A] flex-1">“{item.quote}”</p>
              <div className="mt-8 pt-6 border-t border-[#E7DFD5]">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-[#17181A]">{item.name}</span>
                  <BadgeCheck className="w-4 h-4 text-[#C85A17]" aria-label={t.community.verified} />
                </div>
                <div className="text-sm text-[#5F6368] mt-1">{item.role}</div>
                <div className="mt-4 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider bg-[#E9F2EF] text-[#163832] rounded-full px-3.5 py-1.5">
                  <TrendingUp className="w-3.5 h-3.5 text-[#C85A17]" />{item.trajectory}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
